<div
	class="schedule-alert"
	*ngIf="showAlert"
	[ngClass]="{ 'schedule-alert--success': state === 'success' }"
>
    <div class="close-wrapper">
        <span (click)="close()" class="freud-icon freud-icon-close zk-pointer"></span>
    </div>
	<div *ngIf="state === 'hasDates'" class="zk-flex zk-flex-col zk-gap-2">
		<div class="zk-flex zk-justify-between zk-gap-5">
			<span class="schedule-text">
				{{
					'SESSION.SIDEBAR.SCHEDULE_NEXT_SESSION' | translate: { name: appointment.contact.name }
				}}
			</span>
			<freud-button (click)="scheduleSession()" [loading]="isScheduling">
				<div
					freud-tooltip
					[tooltipLabel]="'SESSION.SIDEBAR.TOOLTIP' | translate"
					class="zk-gap-2 zk-flex zk-items-center zk-justify-between"
				>
					<span class="button-text">{{
						'SESSION.SIDEBAR.SEND_INVITE' | translate
					}}</span>
					<span class="freud-icon freud-icon-send"></span>
				</div>
			</freud-button>
		</div>
		<div class="schedule-date">
			<span class="freud-icon freud-icon-calendar-event"></span>
			<span>{{ getFormatedDate(true) }}</span>
		</div>
	</div>
	<div *ngIf="state === 'emptyDates'">
		<div class="zk-flex zk-flex-col zk-gap-2">
			<span class="schedule-text">
				{{ 'SESSION.SIDEBAR.SCHEDULE_TIP' | translate }}
			</span>
			<span class="schedule-subtitle">
				{{ 'SESSION.SIDEBAR.SCHEDULE_SUBTITLE' | translate }}
			</span>
		</div>
	</div>
	<div *ngIf="state === 'success'">
		<div class="zk-flex zk-flex-col zk-gap-2">
			<span class="schedule-text">{{
				'SESSION.SIDEBAR.INVITE_SENDED_TITLE'
					| translate: { date: getFormatedDate() }
			}}</span>
			<span class="schedule-subtitle">{{
				'SESSION.SIDEBAR.INVITE_SENDED_SUBTITLE' | translate
			}}</span>
		</div>
	</div>
</div>
